import { useEffect, useState } from "@wordpress/element";
import RangeSlider from "./range-slider";
import { getFirstAndLastElement, getStep } from "./util";

function RangeSliderWrapper({
	filterLabel,
	filterType,
	filterValues,
	filterElement,

}) {
	const [filter, setFilter] = useState(null);
	const [step, setStep] = useState(1);
	const applyFilter = async (min, max) => {
		//console.log("apply filter")
		removeFilter();
		let minLabel = filter.labelMin;
		let maxLabel = filter.labelMax;
		Array.from(
			filterElement.querySelectorAll(".wc-block-product-filter-chips__item"),
		)
			.filter((el) => {
				const value = parseFloat(el.getAttribute("value"));
				const label = el.getAttribute("aria-label");
				if (value === min) {
					minLabel = label;
				}
				if (value === max) {
					maxLabel = label;
				}
				return !isNaN(value) && value >= min && value <= max;
			})
			.forEach((el) => el.click());
		setFilter((prev) => ({
			...prev,
			labelMin: minLabel,
			labelMax: maxLabel,
			valueString: `${min}-${max}`,
		}));
	};
	
	const removeFilter = () => {
		//console.log("remove filter")
		document
			.querySelectorAll(".wc-block-product-filter-removable-chips__item")
			.forEach((item) => {
				const label = item
					.querySelector(".wc-block-product-filter-removable-chips__label")
					?.innerText?.trim();
				if (label?.includes(filter.metric)) {
					item
						.querySelector(".wc-block-product-filter-removable-chips__remove")
						?.click();
				}
			});
	};

	const handleFilter = () => {
		if (!filterValues || filterValues.length < 1) return;
		const hasSelection = filterValues.filter((fv) => fv.isSelected);
		const { first, last } = getFirstAndLastElement(filterValues);

		if (hasSelection.length > 0) {
			const selection = getFirstAndLastElement(hasSelection);
			const step = getStep(hasSelection)

			setStep(step)
			setFilter({
				min: Number(first.value),
				max: Number(last.value),
				type: first.type.replace("/", "-"),
				rawLabel: filterLabel,
				metric: extractMetric(first.label),
				labelMin: selection.first.label,
				labelMax: selection.last.label,
				valueString: `${selection.first.value}-${selection.last.value}`,
			});
		} else {
			const step = getStep(filterValues)
			setStep(step)
			setFilter({
				min: Number(first.value),
				max: Number(last.value),
				type: first.type.replace("/", "-"),
				rawLabel: filterLabel,
				metric: extractMetric(first.label),
				labelMin: first.label,
				labelMax: last.label,
				valueString: `${first.value}-${last.value}`,
			});
		}
	}

	useEffect(() => {
		handleFilter()
	}, [filterValues]);

/*
	useEffect(() => {
		document.addEventListener("click", handleClearEvent);
		return () => {
			document.removeEventListener("click", handleClearEvent);
		};
	}, []);*/

	//console.log("FILTER: ", filter);
	//console.log("FILTER values: ", filterValues);
	return (
		filter && (
			<div className="range-filter">
				<RangeSlider
					min={filter.min}
					max={filter.max}
					name={filter.type}
					value={`${filter.valueString}`}
					step={step}
					onChange={(value) => {
						/*Nothing todo*/
					}}
					onChangeEnd={(value) => {
						//console.log("CHANGE END: ", value);
						const currMin = Number(value[0]);
						const currMax = Number(value[1]);

						if (currMin > currMax) {
							applyFilter(currMax, currMin);
						} else {
							applyFilter(currMin, currMax);
						}
					}}
				/>
				<div
					style={{
						margin: "0.5em 0",
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<span class="larf-display-value">{filter.labelMin}</span>
					<span class="larf-display-value">{filter.labelMax}</span>
				</div>
				<div style={{ margin: "0.5em 0" }}>
					<span
						style={{ display: "none" }}
						id={`larf-${filter.type}`}
					>{`${filter.min} — ${filter.max}`}</span>
				</div>
			</div>
		)
	);
}
export default RangeSliderWrapper;

function extractMetric(str) {
	if (!str) {
		return "";
	}
	const match = str.trim().match(/^([+-]?\d+(?:\.\d+)?)\s*(.*)$/);
	if (match) {
		return match[2];
	}
	return "";
}
